import { getCartMutationHandler } from '~/hooks/mutations/get-cart-mutation-handler.js';
import { fetchCartData } from '~/hooks/queries/use-cart-data-query';

export async function addToCart({ productId, quantity, subscriptionScheme }) {
  const { mutationHandler: addToCart } = getCartMutationHandler('addToCart');
  let cart;

  try {
    cart = await addToCart({ productId: parseInt(productId), quantity: parseInt(quantity), subscriptionScheme });
  } catch (e) {
    return undefined;
  }

  return cart;
}

export async function addCartItems(productIds) {
  const { mutationHandler: addCartItems } = getCartMutationHandler('addCartItems');
  let cart;

  try {
    const cartItemsInput = [];
    productIds.forEach(productId => {
      // @todo check if item is subscription toggled
      let isSubscription = false
      let subscriptionScheme = isSubscription ? '1_year' : '0'
      cartItemsInput.push({
        productId,
        quantity: 1,
        subscriptionScheme
      })
    });
    cart = await addCartItems({ cartItemsInput });
  } catch (e) {
    return undefined;
  }

  return cart;
}

export async function getCartData() {
  const { data } = await fetchCartData()

  if (data?.cart) {
    return data.cart
  }

  return null
}

export async function applyCouponHandler({ code }) {
  const { mutationHandler: applyCoupon } = getCartMutationHandler('applyCoupon')
  let cart

  try {
    const { data } = await applyCoupon({ code })

    if (data.applyCoupon?.applied) {
      return data.applyCoupon
    }
  } catch (error) {
    return {
      error: true,
      message: 'There was an error. Please try again or contact support.'
    }
  }

  return null
}

export async function removeCouponsHandler({ couponCodes }) {
  const { mutationHandler: removeCoupons } = getCartMutationHandler('removeCoupons')

  try {
    const { data } = await removeCoupons({ couponCodes })

    if (data) {
      return data
    }
  } catch (error) {
    return {
      error: true,
      message: 'There was an error. Please try again or contact support.'
    }
  }

  return null
}

export async function updateItemQuantities({ cartItemQuantityInput }) {
  const { mutationHandler: updateItemQuantities } = getCartMutationHandler('UpdateItemQuantities');
  let cart;

  try {
    cart = await updateItemQuantities({ cartItemQuantityInput });
  } catch (e) {
    return undefined;
  }

  return cart;
}

export async function removeItemsFromCart({ cartItemKeys = [], removeAll = false }) {
  const { mutationHandler: removeItemsFromCart } = getCartMutationHandler('removeItemsFromCart');
  let cart;

  try {
    cart = await removeItemsFromCart({ cartItemKeys, removeAll });
  } catch (error) {
    return undefined;
  }

  return cart;
}
